var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoursActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#1E1850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9801 19.0731L21.2853 14.0039L22.3471 15.8363C23.8884 15.1513 25.5839 14.7746 27.382 14.7746C34.2152 14.7746 39.7467 20.3061 39.7467 27.1392C39.7467 33.9723 34.2152 39.5039 27.382 39.5039C20.5489 39.5039 15.0002 33.9552 15.0002 27.1221C15.0002 26.6768 15.0174 26.2487 15.0687 25.8206",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8022 21.5878L16.2505 21.7248L17.9802 19.0703",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4977 21.5078L18.8022 21.5934",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.782 21.4375L20.4976 21.506",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.782 21.4378L25.464 21.2494L24.094 18.8861C25.1044 18.4922 26.2004 18.2695 27.365 18.2695C32.2629 18.2695 36.236 22.2427 36.236 27.1406C36.236 32.0385 32.2629 36.0116 27.365 36.0116C22.467 36.0116 18.4939 32.0385 18.4939 27.1406C18.4939 26.6953 18.5281 26.2672 18.5966 25.839",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6732 22.2773V27.4835L23.9912 31.6279",
    stroke: "#CBDB2A",
    strokeWidth: 1.4621,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursActive);
export default __webpack_public_path__ + "static/media/hours-active.ae1bf333a6f3f75844271e0137757fd2.svg";
export { ForwardRef as ReactComponent };